(() => {
class $5b5a46e20f05ce20$var$PromoBlock extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.desktopHeightPixelsIfFullWidth = this.getAttribute('data-desktop-height-pixels-if-full-width');
        this.grid = document.querySelector('ul.product-grid');
        this.promoMediaMobile = this.querySelector('.promo-media-mobile');
        this.promoMediaDesktop = this.querySelector('.promo-media-desktop');
        this.desktopWidthGrid = this.parentElement.getAttribute('data-desktop-width-grid');
        this.hasVideoOnMobile = this.hasAttribute('data-has-video-on-mobile');
        this.hasVideoOnDesktop = this.hasAttribute('data-has-video-on-desktop');
        this.startDate = this.getAttribute('data-start-date');
        this.endDate = this.getAttribute('data-end-date');
        this.href = this.getAttribute('data-href');
        this.handleMobileHeightPixels();
        document.addEventListener('product-grid-view-changed', ()=>{
            this.handleMobileHeightPixels();
        });
        this.observeGrid();
        this.addClickHandler();
        this.handleDate();
    }
    handleDate() {
        if (!this.startDate || !this.endDate) {
            this.parentElement.classList.remove('d-none');
            return;
        }
        const startDate = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        const today = new Date();
        if (today >= startDate && today <= endDate) this.parentElement.classList.remove('d-none');
    }
    addClickHandler() {
        if (!this.href) return;
        this.addEventListener('click', ()=>{
            window.location.href = this.href;
        });
    }
    handleMobileHeightPixels() {
        const productGridView = document.querySelector('ul.product-grid')?.getAttribute('product-grid-view');
        const mobileHeightPixelsIfFullWidth = this.getAttribute('data-mobile-height-pixels-if-full-width');
        if (!productGridView || !mobileHeightPixelsIfFullWidth || !this.promoMediaMobile) return;
        let isPromoBlockFullWidth = false;
        if (productGridView === 'mobile-single' || productGridView === 'default' && this.parentElement?.classList.contains('mobile-width-grid-2')) isPromoBlockFullWidth = true;
        if (isPromoBlockFullWidth && window.innerWidth < 750) {
            this.promoMediaMobile.style.height = this.hasVideoOnMobile ? '100%' : 'auto';
            this.style.height = `${mobileHeightPixelsIfFullWidth}px`;
        } else {
            this.promoMediaMobile.style.height = '100%';
            this.style.height = '100%';
        }
    }
    observeGrid() {
        if (!this.grid) return;
        const observer = new ResizeObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                // Adjust the height of promo block if it takes full width on desktop
                if (window.innerWidth >= 750) {
                    const columnsInGrid = window.getComputedStyle(mutation.target)?.gridTemplateColumns?.split(' ')?.length;
                    let desktopWidthGridNumber = null;
                    if (this.desktopWidthGrid) desktopWidthGridNumber = Number(this.desktopWidthGrid);
                    if (desktopWidthGridNumber && desktopWidthGridNumber >= columnsInGrid) {
                        this.style.height = `${this.desktopHeightPixelsIfFullWidth}px`;
                        this.promoMediaDesktop.style.height = this.hasVideoOnDesktop ? '100%' : 'auto';
                    } else {
                        this.style.height = '100%';
                        this.promoMediaDesktop.style.height = '100%';
                    }
                }
            });
        });
        observer.observe(this.grid, {
            attributes: true
        });
    }
}
if (!customElements.get('promo-block')) customElements.define('promo-block', $5b5a46e20f05ce20$var$PromoBlock);


class $777ff99a87c98b29$var$EmailSignup extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector('.email-signup__form');
        this.emailInput = this.querySelector('input[type="email"]');
        this.marketingCheckbox = this.querySelector('input[name="accepts_marketing"]');
        this.submitButton = this.querySelector('.email-signup__button');
        // Klaviyo configuration - these should be set as data attributes on the element
        this.klaviyoCompanyId = this.getAttribute('data-klaviyo-company-id');
        this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
        this.klaviyoEnabled = this.hasAttribute('data-klaviyo-enabled');
        if (this.form && this.klaviyoEnabled && this.klaviyoCompanyId && this.klaviyoListId) this.form.addEventListener('submit', this.handleSubmit.bind(this));
        else console.warn('Klaviyo integration is not properly configured for EmailSignup component.');
        // Set up button state management
        this.updateButtonState();
        this.emailInput?.addEventListener('input', this.updateButtonState.bind(this));
        this.marketingCheckbox?.addEventListener('change', this.updateButtonState.bind(this));
    }
    updateButtonState() {
        if (!this.submitButton) return;
        const hasEmail = this.emailInput?.value?.trim().length > 0;
        const hasConsent = !this.marketingCheckbox || this.marketingCheckbox.checked;
        this.submitButton.disabled = !hasEmail || !hasConsent;
    }
    async handleSubmit(e) {
        // Only subscribe to Klaviyo if marketing checkbox is checked (or doesn't exist, meaning consent is implied)
        const hasConsent = !this.marketingCheckbox || this.marketingCheckbox.checked;
        if (!hasConsent || !this.emailInput?.value) return;
        const email = this.emailInput.value;
        try {
            const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.klaviyoCompanyId}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/vnd.api+json',
                    'Content-Type': 'application/vnd.api+json',
                    'Revision': '2025-10-15'
                },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'Website Email Signup',
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: email,
                                        subscriptions: {
                                            email: {
                                                marketing: {
                                                    consent: 'SUBSCRIBED'
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        relationships: {
                            list: {
                                data: {
                                    type: 'list',
                                    id: this.klaviyoListId
                                }
                            }
                        }
                    }
                })
            });
            if (response.ok) console.log('Klaviyo subscription successful');
            else console.error('Klaviyo subscription failed:', response.statusText);
        } catch (error) {
            console.error('Klaviyo subscription error:', error);
        }
    }
}
if (!customElements.get('email-signup')) customElements.define('email-signup', $777ff99a87c98b29$var$EmailSignup);


const $c5831b932e5c39a8$var$wrapper = document.querySelector('.quicklinks_wrapper');
if ($c5831b932e5c39a8$var$wrapper) {
    let isDown = false;
    let startX;
    let scrollLeft;
    $c5831b932e5c39a8$var$wrapper.addEventListener('mousedown', (e)=>{
        isDown = true;
        $c5831b932e5c39a8$var$wrapper.classList.add('dragging');
        startX = e.pageX - $c5831b932e5c39a8$var$wrapper.offsetLeft;
        scrollLeft = $c5831b932e5c39a8$var$wrapper.scrollLeft;
    });
    $c5831b932e5c39a8$var$wrapper.addEventListener('mouseleave', ()=>{
        isDown = false;
        $c5831b932e5c39a8$var$wrapper.classList.remove('dragging');
    });
    $c5831b932e5c39a8$var$wrapper.addEventListener('mouseup', ()=>{
        isDown = false;
        $c5831b932e5c39a8$var$wrapper.classList.remove('dragging');
    });
    $c5831b932e5c39a8$var$wrapper.addEventListener('mousemove', (e)=>{
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - $c5831b932e5c39a8$var$wrapper.offsetLeft;
        const walk = (x - startX) * 1.5;
        $c5831b932e5c39a8$var$wrapper.scrollLeft = scrollLeft - walk;
    });
}


class $7e88f3d27489e91c$var$FooterLocalization extends HTMLElement {
    constructor(){
        super();
        this.button = this.querySelector(".footer-localization__button");
        this.panel = this.querySelector(".footer-localization__panel");
        this.bindEvents();
        this.handleVisibility();
    }
    bindEvents() {
        if (this.button) this.button.addEventListener("click", (e)=>this.togglePanel(e));
        document.addEventListener("click", (e)=>this.handleClickOutside(e));
    }
    togglePanel(e) {
        const isExpanded = this.button.getAttribute("aria-expanded") === "true";
        this.button.setAttribute("aria-expanded", !isExpanded);
        this.panel.hidden = isExpanded;
    }
    handleClickOutside(e) {
        if (!this.contains(e.target)) {
            if (this.button) this.button.setAttribute("aria-expanded", "false");
            if (this.panel) this.panel.hidden = true;
        }
    }
    handleVisibility() {
        if (this.getAttribute("data-visibility") === "mobile") {
            const mediaQuery = window.matchMedia("(min-width: 769px)");
            const hideBlock = (e)=>{
                const parentBlock = this.closest(".shopify-block");
                if (parentBlock) parentBlock.style.display = mediaQuery.matches ? "none" : "";
            };
            // Initial check
            hideBlock();
            // Listen for resize
            mediaQuery.addEventListener("change", hideBlock);
        }
    }
}
customElements.define("footer-localization", $7e88f3d27489e91c$var$FooterLocalization);


class $96845dc771932159$var$ReturnsAggregatorComponent extends HTMLElement {
    connectedCallback() {
        this.countryUrls = {};
        this.fallbackUrl = this.getAttribute('data-fallback-url') || '';
        this.selectedCountryCode = this.getAttribute('data-current-country') || '';
        try {
            this.countryUrls = JSON.parse(this.getAttribute('data-country-urls') || '{}');
        } catch (e) {
        // Fall back to empty map
        }
        this.trigger = this.querySelector('[data-ref="trigger"]');
        this.triggerLabel = this.querySelector('[data-ref="triggerLabel"]');
        this.dropdown = this.querySelector('[data-ref="dropdown"]');
        this.search = this.querySelector('[data-ref="search"]');
        this.list = this.querySelector('[data-ref="list"]');
        this.noResults = this.querySelector('[data-ref="noResults"]');
        this.cta = this.querySelector('[data-ref="cta"]');
        this.items = [
            ...this.list.querySelectorAll('[role="option"]')
        ];
        this.trigger.addEventListener('click', ()=>this.toggleDropdown());
        this.trigger.addEventListener('keydown', (e)=>{
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                this.openDropdown();
            } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
                this.openDropdown();
                this.search.value = e.key;
                this.filterCountries();
            }
        });
        this.search.addEventListener('input', ()=>this.filterCountries());
        this.list.addEventListener('click', (e)=>{
            const item = e.target.closest('[role="option"]:not([hidden])');
            if (item && item !== this.noResults) this.selectCountry(item);
        });
        document.addEventListener('click', (e)=>{
            const isDropdown = this.dropdown.contains(e.target);
            const isTrigger = this.trigger.contains(e.target);
            const isCta = this.cta && this.cta.contains(e.target);
            if (!isDropdown && !isTrigger && !isCta) this.closeDropdown();
        });
        this.search.addEventListener('keydown', (e)=>{
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const first = this.items.find((item)=>!item.hidden);
                if (first) first.focus();
            } else if (e.key === 'Escape') this.closeDropdown();
        });
        this.list.addEventListener('keydown', (e)=>{
            const focused = document.activeElement;
            if (!focused || !focused.matches('[role="option"]')) return;
            const visible = this.items.filter((item)=>!item.hidden);
            const index = visible.indexOf(focused);
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (index < visible.length - 1) visible[index + 1].focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (index > 0) visible[index - 1].focus();
                else this.search.focus();
            } else if (e.key === 'Enter') {
                e.preventDefault();
                this.selectCountry(focused);
            } else if (e.key === 'Escape') this.closeDropdown();
        });
        this.updateCtaUrl();
    }
    toggleDropdown() {
        if (this.dropdown.hidden) this.openDropdown();
        else this.closeDropdown();
    }
    openDropdown() {
        this.dropdown.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.search.value = '';
        this.filterCountries();
        this.search.focus();
    }
    closeDropdown() {
        this.dropdown.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
    }
    filterCountries() {
        const query = this.search.value.toLowerCase().trim();
        let visibleCount = 0;
        this.items.forEach((item)=>{
            if (item === this.noResults) return;
            const name = (item.getAttribute('data-country-name') || '').toLowerCase();
            const iso = (item.getAttribute('data-value') || '').toLowerCase();
            const aliases = (item.getAttribute('data-aliases') || '').toLowerCase();
            const match = !query || name.includes(query) || iso.includes(query) || aliases.includes(query);
            item.hidden = !match;
            if (match) visibleCount++;
        });
        this.noResults.hidden = visibleCount > 0;
    }
    selectCountry(item) {
        this.items.forEach((i)=>i.setAttribute('aria-selected', 'false'));
        item.setAttribute('aria-selected', 'true');
        this.selectedCountryCode = item.getAttribute('data-value');
        this.triggerLabel.textContent = item.getAttribute('data-country-name');
        this.updateCtaUrl();
        this.closeDropdown();
        this.trigger.focus();
    }
    updateCtaUrl() {
        const url = this.countryUrls[this.selectedCountryCode] || this.fallbackUrl;
        if (this.cta && url) this.cta.href = url;
    }
}
if (!customElements.get('returns-aggregator-component')) customElements.define('returns-aggregator-component', $96845dc771932159$var$ReturnsAggregatorComponent);



})();
//# sourceMappingURL=parcel_scripts.js.map
